import { colorTagsApi, useColorTags } from '@entities/common/color-tags';
import React from 'react';
import { xhr } from '@shared/config';

export const useLoadColorTags = () => {
  const { setColorTags } = useColorTags();

  const loadColorTags = () => {
    const load = async () => {
      try {
        const res = await xhr.get(colorTagsApi);

        setColorTags(res.data);
      } catch (error) {}
    };

    load();
  };

  React.useEffect(loadColorTags, []);
  return {};
};
